import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../../api-tags';

export const SLACK_CALLBACK_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PUBLIC,
  route: '/integrations/slack/auth/callback',
  tags: NEST_API_TAGS.INTEGRATIONS,
} satisfies ZapiPath;

export type SlackCallbackPath = typeof SLACK_CALLBACK_PATH;